import React, { useEffect, useState } from "react";
import { Next } from "../Icons/Icons";

const LinkBox = ({ title, subtitle, value, onChange }) => {
  const [validLink, setValidLink] = useState(false);
  const [resolvedLink, setResolvedLink] = useState(null);

  useEffect(() => {
    if (!value || value.trim() === "") {
      setValidLink(false);
      setResolvedLink(null);
      return;
    }

    const trimmed = value.trim();

    // Si no trae protocolo, asumimos http://
    const normalizedValue = /^https?:\/\//i.test(trimmed)
      ? trimmed
      : `http://${trimmed}`;

    try {
      const url = new URL(normalizedValue);

      if (url.protocol === "http:" || url.protocol === "https:") {
        setValidLink(true);
        setResolvedLink(normalizedValue);
        return;
      }
    } catch {
      // noop
    }

    setValidLink(false);
    setResolvedLink(null);
  }, [value]);

  return (
    <>
      <div style={{ fontWeight: 600, fontSize: "16px", marginBottom: "4px" }}>
        {title}
      </div>

      <div
        style={{
          fontSize: "14px",
          color: "#6c757d",
          marginBottom: "8px",
        }}
      >
        {subtitle}
      </div>

      <div style={{ display: "flex", position: "relative" }}>
        <select
          style={{
            position: "absolute",
            left: "12px",
            top: "50%",
            transform: "translateY(-50%)",
            border: "none",
            background: "transparent",
            fontSize: "14px",
            color: "#6c757d",
            paddingRight: "8px",
            appearance: "none",
          }}
        >
          <option>Link</option>
        </select>

        <input
          type="text"
          placeholder="https://"
          value={value}
          onChange={(e) => onChange?.(e.target.value)}
          style={{
            width: "100%",
            padding: "10px 12px 10px 60px",
            borderRadius: "10px",
            border: "1px solid #dee2e6",
            fontSize: "14px",
            color: "#495057",
          }}
        />

        {validLink && (
          <button
            className="btn-table-actions"
            onClick={() => {
              window.open(resolvedLink, "_blank", "noopener");
            }}
          >
            <Next />
          </button>
        )}
      </div>
    </>
  );
};

export default LinkBox;
